import React from "react"
import { Title } from "../../components"
import servicesData from "./servicesData"
import {
  Container,
  Content,
  Service,
  FrontPage,
  BackPage,
  Text,
  LanguagesContainer,
  SubHeader,
  Header,
  Tags,
  IconStyle,
} from "./Service.styled"

const Services = () => {
  return (
    <Container id="service">
      <Title title="services" />
      <Content>
        {servicesData.map(service => {
          const { id, icon, title, text, tools } = service

          return (
            <Service key={id}>
              <FrontPage>
                <Header>{title}</Header>
                <div className="underline"></div>
                <IconStyle>{icon}</IconStyle>
              </FrontPage>

              <BackPage>
                <Text>{text}</Text>
                <LanguagesContainer>
                  <SubHeader>Languages</SubHeader>
                  <Tags>
                    {tools.map(tool => (
                      <span key={tool}>{tool}</span>
                    ))}
                  </Tags>
                </LanguagesContainer>
              </BackPage>
            </Service>
          )
        })}
      </Content>
    </Container>
  )
}

export default Services
